export const changeTo = (table) => ({
  type: "CHANGE_TO",
  payload: table,
})
